import {
  AlertIcon,
  ArchiveIcon,
  BeakerIcon,
  BookmarkIcon,
  BriefcaseIcon,
  BugIcon,
  CalendarIcon,
  ClockIcon,
  CodeReviewIcon,
  CodescanIcon,
  CommentDiscussionIcon,
  DependabotIcon,
  EyeIcon,
  FileDiffIcon,
  FlameIcon,
  GearIcon,
  GitPullRequestIcon,
  HomeIcon,
  HubotIcon,
  type Icon,
  IssueOpenedIcon,
  LinkIcon,
  MentionIcon,
  MeterIcon,
  MoonIcon,
  NorthStarIcon,
  OrganizationIcon,
  PeopleIcon,
  PersonIcon,
  RepoForkedIcon,
  RepoIcon,
  RepoLockedIcon,
  RepoTemplateIcon,
  RocketIcon,
  SmileyIcon,
  SquirrelIcon,
  SunIcon,
  TelescopeIcon,
  TerminalIcon,
  ToolsIcon,
  ZapIcon,
} from '@primer/octicons-react'

export interface UserShortcut {
  id: string
  name: string
  searchType: 'repositories'
  query: string
  description?: string
  icon: IconName
  color?: IconColor
}

/// Returns the class name for the icon color based on the provided color string.
export function getIconColorClassName(color: string | undefined) {
  const key = color?.toLowerCase() as IconColor
  return colorMap[key] || 'color-fg-muted'
}

export function getIconComponent(name: string): Icon {
  const key = name.toLowerCase() as IconName
  return iconMap[key] || BookmarkIcon
}

const colorMap = {
  ['gray']: 'color-fg-muted',
  ['blue']: 'color-fg-accent',
  ['green']: 'color-fg-success',
  ['orange']: 'color-fg-severe',
  ['red']: 'color-fg-danger',
  ['pink']: 'color-fg-sponsors',
  ['purple']: 'color-fg-done',
} as const

type IconColor = keyof typeof colorMap

const iconMap = {
  ['people']: PeopleIcon,
  ['smiley']: SmileyIcon,
  ['mention']: MentionIcon,
  ['clock']: ClockIcon,
  ['git_pull_request']: GitPullRequestIcon,
  ['zap']: ZapIcon,
  ['issue_opened']: IssueOpenedIcon,
  ['person']: PersonIcon,
  ['comment_discussion']: CommentDiscussionIcon,
  ['organization']: OrganizationIcon,
  ['briefcase']: BriefcaseIcon,
  ['file_diff']: FileDiffIcon,
  ['code_review']: CodeReviewIcon,
  ['codescan']: CodescanIcon,
  ['terminal']: TerminalIcon,
  ['tools']: ToolsIcon,
  ['beaker']: BeakerIcon,
  ['alert']: AlertIcon,
  ['eye']: EyeIcon,
  ['telescope']: TelescopeIcon,
  ['bookmark']: BookmarkIcon,
  ['calendar']: CalendarIcon,
  ['meter']: MeterIcon,
  ['moon']: MoonIcon,
  ['sun']: SunIcon,
  ['flame']: FlameIcon,
  ['bug']: BugIcon,
  ['north_star']: NorthStarIcon,
  ['rocket']: RocketIcon,
  ['squirrel']: SquirrelIcon,
  ['hubot']: HubotIcon,
  ['dependabot']: DependabotIcon,
  ['repo']: RepoIcon,
  ['repo-locked']: RepoLockedIcon,
  ['link']: LinkIcon,
  ['repo-forked']: RepoForkedIcon,
  ['repo-template']: RepoTemplateIcon,
  ['archive']: ArchiveIcon,
  ['home']: HomeIcon,
  ['gear']: GearIcon,
} as const

type IconName = keyof typeof iconMap
